import { StatusInfo } from "../common/Status";
import { AccountPaymentMethodStatus } from "./types";

export function getAccountPaymentMethodStatusInfo(status: AccountPaymentMethodStatus): StatusInfo {
	const map: Record<AccountPaymentMethodStatus, StatusInfo> = {
		ACTIVE: { text: 'Activo', class: 'success', actionText: '' },
		INACTIVE: { text: 'Inactivo', class: 'danger', actionText: '' },
	};

	return map[status] ?? { text: String(status), class: 'secondary' };
}